<div class="toast-wrapper" aria-live="polite" aria-atomic="true">
  <div *ngFor="let t of toasts" class="toast show" role="alert" aria-live="assertive" aria-atomic="true">
    <div class="toast-header">
      <strong class="me-auto">{{t.title || 'Notification'}}</strong>
      <small class="text-muted ms-2">{{t.time | date:'shortTime'}}</small>
      <button type="button" class="btn-close ms-2 mb-1" aria-label="Close" (click)="removeToast(t.id)"></button>
    </div>
    <div class="toast-body">{{t.body}}</div>
  </div>
</div>
